<img
	tabindex="0"
	class="zk-hidden lg:zk-flex"
	src="../../../../assets/images/logo.svg"
	alt="ZenOffice"
/>
<img
	tabindex="0"
	class="zk-flex lg:zk-hidden"
	src="../../../../assets/images/logo-sm.svg"
	alt="ZenOffice"
/>
